import { render, staticRenderFns } from "./Wrong.vue?vue&type=template&id=34d81b42&scoped=true&"
import script from "./Wrong.vue?vue&type=script&lang=js&"
export * from "./Wrong.vue?vue&type=script&lang=js&"
import style0 from "./Wrong.vue?vue&type=style&index=0&id=34d81b42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d81b42",
  null
  
)

export default component.exports